import { Component, forwardRef, Inject, Injector, Optional } from '@angular/core';
import { UntypedFormControl, NG_ASYNC_VALIDATORS, NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';

import { IpAddressService } from '@common/services';
import { InputBase } from '@ui/components/form/base/input-base';

@Component({
    selector: 'aa-input-ipv6',
    templateUrl: './input-ip.component.html',
    styleUrls: [
        '../input.component.scss'
    ],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => InputIpv6Component),
            multi: true,
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => InputIpv6Component),
            multi: true,
        }
    ],
    standalone: false
})
export class InputIpv6Component extends InputBase<string>
{
    private static identifier: number = 0;

    constructor(
        @Optional() @Inject(NG_ASYNC_VALIDATORS) asyncValidators: Array<any>,
        private ipAddressService: IpAddressService,
        injector: Injector
    )
    {
        super(injector);

        this.fieldId = `id-input-ipv6-${InputIpv6Component.identifier++}`;
    }

    validate ({ value }: UntypedFormControl)
    {
        return this.ipAddressService.validateIpv6Address(value);
    }
}
